"use client"

import Tooltip from "@alwaysgeeky-games/shared-ui-components/Tooltip"
// import { CaptchaManager } from "components/CaptchaManager/CaptchaManager"
import { AppendedInput } from "components/Form/AppendedInput"
import Button from "@alwaysgeeky-games/shared-ui-components/Button"
import { CustomLink } from "components/Form/CustomLink"
import { FormActionError } from "components/Form/FormActionError"
import InputContainer from "@alwaysgeeky-games/shared-ui-components/InputContainer"
import { SquareCheckbox } from "components/Form/SquareCheckbox"
import { TextInput } from "components/Form/TextInput"
import { LoadingSpinnerContainer } from "components/LoadingSpinnerContainer/LoadingSpinnerContainer"
import { useSignInForm } from "components/SignInForm/hooks/useSignInForm"
import dynamic from "next/dynamic"
import { useRouter, useSearchParams } from "next/navigation"
import { useEffect } from "react"
// import { GoogleIcon } from "@alwaysgeeky-games/shared-ui-components/Icons/GoogleIcon/GoogleIcon"
// import { AppleIcon } from "@alwaysgeeky-games/shared-ui-components/Icons"
// import { FeatureFlag } from "components/FeatureFlag/FeatureFlag"

const SessionConnected = dynamic(
  () =>
    import("components/SessionConnected/SessionConnected").then(
      mod => mod.SessionConnected
    ),
  { ssr: false, loading: () => <LoadingSpinnerContainer /> }
)
const SignInFormEmailSent = dynamic(() =>
  import("components/SignInForm/SignInFormEmailSent").then(
    mod => mod.SignInFormEmailSent
  )
)

export const SignInForm = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const {
    selectors: {
      errors,
      rememberMe,
      emailSent,
      actionError,
      isSigningIn,
      isConnected,
      isValid,
      formRef,
      // formTries,
      // isCaptchaReady,
    },
    actions: {
      handleSignInForm,
      register,
      handleEmailSentReset,
      handleSignInAgain,
      // setIsCaptchaReady,
    },
  } = useSignInForm()

  useEffect(() => {
    const account = searchParams.get("account")

    if (account === "create") {
      const orgId = searchParams.get("orgId")
      const bundle = searchParams.get("bundle")

      router.replace(`/wallet-connect?orgId=${orgId}&bundle=${bundle}`)
    }
  }, [])

  if (isConnected) {
    return <SessionConnected handleSignInAgain={handleSignInAgain} />
  }

  if (emailSent) {
    return <SignInFormEmailSent handleEmailSentReset={handleEmailSentReset} />
  }

  // const googleAuthUrl = `${process.env.NEXT_PUBLIC_COGNITO_DOMAIN}/oauth2/authorize?identity_provider=Google&scope=aws.cognito.signin.user.admin+openid+profile+email&response_type=code&client_id=${process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID}&redirect_uri=${encodeURIComponent(process.env.NEXT_PUBLIC_COGNITO_REDIRECT_URI!)}&state=provider%3Dgoogle`
  // const appleAuthUrl = `${process.env.NEXT_PUBLIC_COGNITO_DOMAIN}/oauth2/authorize?identity_provider=SignInWithApple&scope=aws.cognito.signin.user.admin+openid+profile+email&response_type=code&client_id=${process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID}&redirect_uri=${encodeURIComponent(process.env.NEXT_PUBLIC_COGNITO_REDIRECT_URI!)}&state=provider%3DSignInWithApple`

  return (
    <form
      onSubmit={handleSignInForm}
      ref={formRef}
      className="flex flex-col gap-4"
    >
      <fieldset className="flex flex-col gap-4">
        <InputContainer
          id="email"
          label="Email address"
          labelClassName="text-sm"
          error={errors.email?.message}
        >
          <TextInput
            id="email"
            type="email"
            registeredField={register("email")}
            maxLength={255}
          />
        </InputContainer>
        <InputContainer
          id="password"
          label="Password"
          labelClassName="text-sm"
          error={errors.password?.message}
        >
          <AppendedInput
            id="password"
            type="password"
            registeredField={register("password")}
            autoComplete="current-password"
          />
        </InputContainer>
        <div className="flex justify-between text-base items-center">
          <SquareCheckbox
            id="rememberMe"
            label="Remember me"
            type="check"
            className="-ms-2"
            checked={rememberMe}
            registeredField={register("rememberMe")}
          />

          <CustomLink href="/forgot-password">Forgot your password?</CustomLink>
        </div>
      </fieldset>
      {actionError && <FormActionError message={actionError} />}
      <div className="text-right md:w-2/3 w-full mx-auto flex flex-col gap-4">
        <div className="md:w-3/4 w-full mx-auto flex flex-col gap-4">
          {/* <Tooltip content="Initializing captcha..." disabled={isCaptchaReady}> */}
          {/* <Tooltip content="Initializing captcha..."> */}
          <div className="flex flex-1 flex-row items-center justify-center w-full">
            <Button
              id="form-submit-button"
              fullWidth
              size="large"
              type="submit"
              label="Sign in"
              // disabled={isSigningIn || !isValid || !isCaptchaReady}
              // isLoading={isSigningIn || !isCaptchaReady}
              disabled={isSigningIn || !isValid}
              isLoading={isSigningIn}
            />
          </div>
          {/* </Tooltip> */}

          <div className="flex gap-4 items-center py-2">
            <hr className="w-full" />
            <span className="text-base text-gray-400">or</span>
            <hr className="w-full" />
          </div>
        </div>
        {/* <FeatureFlag featureName="signinwithgoogle">
          <Button
            type="button"
            size="large"
            variant="secondary"
            label="Continue with Google"
            icon={GoogleIcon}
            onClick={() => {
              window.location.href = googleAuthUrl
            }}
          />
          <Button
            type="button"
            size="large"
            variant="secondary"
            label="Continue with Apple"
            icon={AppleIcon}
            onClick={() => {
              window.location.href = appleAuthUrl
            }}
          />
        </FeatureFlag> */}
        {/* <Button
          disabled
          size="large"
          variant="secondary"
          label="Continue with Facebook"
          icon={FacebookIcon}
        /> */}

        <div className="text-center text-sm pt-2">
          Don&apos;t have an account?
          <br />
          <CustomLink href="/sign-up" className="underline">
            Sign Up!
          </CustomLink>
        </div>
      </div>
      {/* <CaptchaManager key={formTries} handleSetReady={setIsCaptchaReady} /> */}
    </form>
  )
}
